/**
 * KAN-883: фильтр "Появился" страницы "Лиды по теплоте" в адресе
 * (lib/leadDayPeriod). Каждая смена зовёт onChange (первая страница, без
 * выбора строк).
 */
import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { LEAD_DAY_PARAM, parseLeadDayRange, withLeadDayRange } from '@/lib/leadDayPeriod';
import type { CrmRange } from '@/lib/crmTable';

export interface LeadDayState {
  /** null - всё время. */
  range: CrmRange | null;
  setRange: (range: CrmRange) => void;
  setAllTime: () => void;
}

export function useLeadDayPeriod(onChange: () => void): LeadDayState {
  const [params, setParams] = useSearchParams();
  const from = params.get(LEAD_DAY_PARAM.from);
  const to = params.get(LEAD_DAY_PARAM.to);
  const range = useMemo(() => parseLeadDayRange(from, to), [from, to]);

  const writeRange = useCallback(
    (next: CrmRange | null) => {
      setParams((prev) => withLeadDayRange(prev, next), { replace: true });
      onChange();
    },
    [setParams, onChange]
  );
  const setAllTime = useCallback(() => writeRange(null), [writeRange]);

  return { range, setRange: writeRange, setAllTime };
}
